import { InlineText2 } from '@cian/ui-kit/typography/InlineText/InlineText';

import React, { memo } from 'react';

/**
 * @start
 * @todo Удалить строку с RS
 * @description Данный функционал появился в задаче CD-93943, будет удалён в задаче CD-97932
 */
import { useCoworkingWorkplacePriceEnabledRS } from '../../../hooks/useCoworkingWorkplacePriceEnabledRS';

import * as styles from './CoworkingPriceDesc.css';
import { CoworkingPriceTypeDropdown } from './internal/components/CoworkingPriceTypeDropdown';

export const CoworkingPriceDesc = memo(function CoworkingPriceDesc() {
  /**
   * @start
   * @todo Удалить строку с RS
   * @description Данный функционал появился в задаче CD-93943, будет удалён в задаче CD-97932
   */
  const coworkingWorkplacePriceEnabledRS = useCoworkingWorkplacePriceEnabledRS();

  return (
    <div className={styles['container']}>
      <InlineText2>₽/мес.</InlineText2>
      &nbsp;
      {/**
       * @todo Удалить ветвление с RS
       * @description Данный функционал появился в задаче CD-93943, будет удалён в задаче CD-97932
       */
      coworkingWorkplacePriceEnabledRS ? <CoworkingPriceTypeDropdown /> : <InlineText2>за весь офис</InlineText2>}
    </div>
  );
});
